import {makeStyles} from 'external/material'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    '& .label' : {
      color: '#69738c',
      fontWeight: 'bold'
    }
  },
  premise: {
    '& > .label': {
      marginBottom: 20
    }
  },
  answer: {
    marginTop: 25,
    '& .content': {
      paddingLeft: 10
    }
  }
}))

export {useStyles as default}
